import React, { useState } from "react";
import DialogActions from "@material-ui/core/DialogActions";
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";

import resendMail from "../general/modalResendMail";
import { MySnackbar } from "../mySnackbar/MySnackbar";
import { useMediaQuery, useTheme } from "@material-ui/core";

const ResendMail = ({
  linkActiveMail,
  errorMessage,
  resendLinkMail,
  setLinkActiveMail,
  setLoading,
}) => {
  const [snack, setSnack] = useState({
    message: "",
    show: false,
    severity: "success",
  });

  const handleCloseDialogSendMail = () => {
    if (setLinkActiveMail) setLinkActiveMail(false);
  };

  const resendMailFromForgot = async () => {
    setLoading(true);
    const response = await resendMail(resendLinkMail);
    if (response && response.data.success === true) {
      setSnack({
        message: response.data.Message,
        show: true,
        severity: "success",
      });
      if (setLinkActiveMail) setLinkActiveMail(false);
    } else {
      const message = response?.data?.Message || "Erreur de connection !!!";
      setSnack({ message: message, show: true, severity: "error" });
    }
    setLoading(false);
  };

  const theme = useTheme();
  const querysmDown = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div>
      <MySnackbar params={snack} />
      {linkActiveMail ? (
        <DialogActions
          className="errorDialogBox"
          style={{
            position: "absolute", // Positionner l'élément par rapport à son parent
            top: "50%", // Le pousser à 50% du haut du conteneur
            transform: "translate(-50%, -50%)", // Recentrer en utilisant translate
            zIndex: 10000,
          }}
        >
          <IconButton onClick={handleCloseDialogSendMail}>
            <CancelIcon />
          </IconButton>
          <h2 style={{ width: "100%", marginTop: "-10px" }}>{errorMessage}</h2>
          <p style={{ width: "100%", marginTop: "-10px" }}>
            Souhaitez vous que nous vous renvoyons un lien d'activation sur
            votre email ?
            <Button
              onClick={resendMailFromForgot}
              variant="contained"
              style={{
                flexBasis: "20%",
                marginBottom: "25px",
                marginLeft: querysmDown ? "auto" : "20px",
                marginTop: querysmDown ? "20px" : "auto",
              }}
            >
              M'envoyer le lien d'activation
            </Button>
          </p>
        </DialogActions>
      ) : null}
    </div>
  );
};

export default ResendMail;
